import React, { useEffect, useId } from 'react';
import { useForm } from 'react-hook-form';
import DraggableDialog from '@components-clean/core/draggable-dialog';
import { TextBoxController } from '@components-clean/core/text-box';
import { useTranslation } from '@hooks/index';
import { SubjectHubConfigFieldEditDialogFormValues } from './types';

type Props = {
    defaultValues: SubjectHubConfigFieldEditDialogFormValues;
    onCancel: () => void;
    onSubmit: (values: SubjectHubConfigFieldEditDialogFormValues) => unknown;
};

const SubjectHubConfigFieldEditDialog = ({ defaultValues, onCancel, onSubmit }: Props) => {
    const { t } = useTranslation('admin', {
        keyPrefix: 'subjectConfig.subjectHub.editFieldDialog',
    });

    const {
        control,
        handleSubmit,
        formState: { isDirty, isValid, isSubmitting },
    } = useForm({ mode: 'all', defaultValues });

    const canSubmit = isDirty && isValid && !isSubmitting;

    const labelFieldId = useId();

    // Autofocus label input on mount (the `autoFocus` property doesn't work)
    useEffect(() => {
        const input = document.querySelector(`#${labelFieldId}`);

        if (input instanceof HTMLInputElement) {
            input.focus();
        }
    }, [labelFieldId]);

    return (
        <DraggableDialog
            dataTestId="subject-hub-config-edit-dialog"
            title={t('title')}
            onClose={onCancel}
            onSubmit={handleSubmit(onSubmit) as (e: unknown) => unknown}
            primaryBtnDisabled={!canSubmit}
            height={160}
            width={400}
        >
            <TextBoxController
                id={labelFieldId}
                data-testid="subject-hub-config-edit-dialog-field-label"
                control={control}
                name="label"
                label={t('fields.label')}
                required
                maxLength={50}
            />
        </DraggableDialog>
    );
};

export default SubjectHubConfigFieldEditDialog;
